import { render } from "./Paginate.vue?vue&type=template&id=c2b187c2&scoped=true&ts=true"
import script from "./Paginate.ts?vue&type=script&lang=ts"
export * from "./Paginate.ts?vue&type=script&lang=ts"

import "./Paginate.scss?vue&type=style&index=0&id=c2b187c2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2b187c2"]])

export default __exports__